import styled from "styled-components"
import tw from "twin.macro"

const ImgCaption = styled.p`
  ${tw`m-0 mt-6 mb-2 text-base text-grey-600`}
`

export default ImgCaption
